<template>
  <SelectApi endpoint="freight_company_service_codes" itemTitle="code" />
</template>

<script>
export default {
  name: 'SelectFreightCompanyServiceCode'
};
</script>
